var TimeFormatOptions = /* @__PURE__ */ ((TimeFormatOptions2) => {
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_24"] = 1] = "TIME_FORMAT_24";
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_12"] = 2] = "TIME_FORMAT_12";
  return TimeFormatOptions2;
})(TimeFormatOptions || {});
var GTMevents = /* @__PURE__ */ ((GTMevents2) => {
  GTMevents2["registrationModalOpened"] = "open_registration_modal";
  GTMevents2["registrationSecondStep"] = "registration_button_step2";
  GTMevents2["registrationThirdStep"] = "registration_button_step3";
  GTMevents2["registrationSuccess"] = "registration_success";
  GTMevents2["signIn"] = "sign_in";
  GTMevents2["firstDeposit"] = "first_deposit";
  GTMevents2["deposit"] = "deposit";
  GTMevents2["betConfirm"] = "betconfirm";
  GTMevents2["playGame"] = "play_game";
  GTMevents2["depositError"] = "deposit_error";
  GTMevents2["regFormAutoShow"] = "regFormAutoShow";
  GTMevents2["regFormRenderA"] = "reg_render_A";
  GTMevents2["regFormRenderB"] = "reg_render_B";
  GTMevents2["regSuccessA"] = "reg_success_A";
  GTMevents2["regSuccessB"] = "reg_success_B";
  return GTMevents2;
})(GTMevents || {});
var UIPortalType = /* @__PURE__ */ ((UIPortalType2) => {
  UIPortalType2["base"] = "base-portal";
  UIPortalType2["custom"] = "custom-portal";
  UIPortalType2["notice"] = "notice-portal";
  UIPortalType2["cashier"] = "cashier-portal";
  return UIPortalType2;
})(UIPortalType || {});
const portalActiveClass = "portal-active";
var CheckboxStyle = /* @__PURE__ */ ((CheckboxStyle2) => {
  CheckboxStyle2["default"] = "default";
  CheckboxStyle2["square"] = "square";
  CheckboxStyle2["greenSquare"] = "greenSquare";
  CheckboxStyle2["rounded"] = "rounded";
  return CheckboxStyle2;
})(CheckboxStyle || {});
var FetchingStatusess = /* @__PURE__ */ ((FetchingStatusess2) => {
  FetchingStatusess2["none"] = "NONE";
  FetchingStatusess2["progress"] = "PROGRESS";
  FetchingStatusess2["success"] = "SUCCESS";
  FetchingStatusess2["error"] = "ERROR";
  return FetchingStatusess2;
})(FetchingStatusess || {});
export {
  CheckboxStyle,
  FetchingStatusess,
  GTMevents,
  TimeFormatOptions,
  UIPortalType,
  portalActiveClass
};
